import { useEffect, useState } from "react";
import { Alert } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth/msalConfig";
import { postVerifyPlusEntraToken } from "../../services/apiService";

const EntraLoginFlow = ({ onSessionResolved, onError }) => {
  const { instance } = useMsal();
  const [status, setStatus] = useState("");

  useEffect(() => {
    let cancelled = false;

    const verifyToken = async (idToken) => {
      setStatus("Validando sesion con Microsoft...");
      try {
        const response = await postVerifyPlusEntraToken(idToken);
        if (cancelled) {
          return;
        }

        const sesion = response?.data?.sesion;
        const azureUser = response?.data?.azureUser || null;
        if (sesion) {
          onSessionResolved(sesion, azureUser, response?.data || {});
          return;
        }

        onError("La respuesta del servidor no incluyo la sesion esperada.");
      } catch (error) {
        if (cancelled) {
          return;
        }

        const message =
          error?.response?.data?.error ||
          error?.message ||
          "No fue posible validar el acceso con Microsoft.";
        onError(message);
      } finally {
        if (!cancelled) {
          setStatus("");
        }
      }
    };

    const processRedirect = async () => {
      try {
        const redirectResult = await instance.handleRedirectPromise();
        if (cancelled) {
          return;
        }

        if (redirectResult?.account) {
          instance.setActiveAccount(redirectResult.account);
        }

        if (redirectResult?.idToken) {
          await verifyToken(redirectResult.idToken);
          return;
        }

        const account =
          instance.getActiveAccount() || instance.getAllAccounts()[0];
        if (!account) {
          return;
        }

        instance.setActiveAccount(account);
        const silentResult = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });

        if (silentResult?.idToken) {
          await verifyToken(silentResult.idToken);
        }
      } catch (error) {
        if (!cancelled) {
          const message =
            error?.message ||
            "No fue posible completar el flujo con Microsoft.";
          onError(message);
        }
      }
    };

    processRedirect();

    return () => {
      cancelled = true;
    };
  }, [instance, onError, onSessionResolved]);

  if (!status) {
    return null;
  }

  return <Alert severity="info">{status}</Alert>;
};

export default EntraLoginFlow;
